import React from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'

import { isCustomerUser } from 'selectors/authSelectors'
import Button from 'discada/dist/Button'

import './Menuing.scss'

export function MenuItem(props) {
  let {
    item,
    itemIndex,
    labelRenderer,
    valueRenderer,
    remove,
    noValue,
    isDealer,
    onClick = () => {},
  } = props

  if (!item || item.hide) return null

  let label =
    typeof labelRenderer === 'function'
      ? labelRenderer(item, itemIndex)
      : item.name || item.label

  return (
    <div
      key={itemIndex}
      className={cn('menu-item', item.className, {
        'no-value': noValue,
      })}
      onClick={() => onClick(item, itemIndex)}
    >
      <div className="menu-item-content">
        {label && <span className="menu-item-label">{label}</span>}

        {!noValue && (
          <span className="menu-item-value value">
            {valueRenderer ? valueRenderer(item, itemIndex) : item.value}
          </span>
        )}
      </div>

      {remove && isDealer && (
        <div className="menu-item-remove">
          <Button
            icon="times"
            size="small"
            className="remove"
            onClick={() => remove(item, itemIndex)}
            tabIndex="-1"
          />
        </div>
      )}
    </div>
  )
}

export function Menuing(props) {
  let { items = [], className } = props

  return (
    <div className={cn('menuing-wrapper', className)}>
      {items.map((c, i) => (
        <MenuItem key={i} item={c} itemIndex={i} {...props} />
      ))}
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    isDealer: !isCustomerUser(state),
  }
}

export default connect(mapStateToProps)(Menuing)
